import { UserProfession } from '~/enums/UserProfession';
import { Colors } from '~/themes/colors';
import { Column, Row, Text } from '~/commonComponents';
import { useMediaQuery } from '~/hooks';
import { ProfessionalNameRow } from '../shared/ProfessionalNameRow';
import { ActivityLevelInfo } from '../shared/ActivityLevelInfo';
import AttendanceBadgeInline from '../shared/AttendanceBadgeInline';
import { IProfessionalCardUser } from '../../interfaces';

interface IProfessionalCardDetailsNewProps {
  user: IProfessionalCardUser;
}

export const ProfessionalCardDetailsNew = ({
  user,
}: IProfessionalCardDetailsNewProps) => {
  const {
    id, fullname, profession, rating,
    isAvailable, yearsOfExperience, badges, activityLevel,
  } = user;
  const textColor = Colors.neutral_500;
  const hasBadges = badges && badges.length > 0;
  const [isSmallScreen] = useMediaQuery(['mlg']);

  const renderActivityLine = () => (
    <Row alignItems="center" style={{ whiteSpace: 'nowrap' }}>
      {activityLevel && (
        <ActivityLevelInfo activityLevel={activityLevel} isAvailable />
      )}
      {!isAvailable && (
        <Text color={Colors.error_500}>
          {activityLevel && <>&nbsp;&nbsp;&bull;&nbsp;&nbsp;</>}
          Currently Unavailable
        </Text>
      )}
    </Row>
  );

  return (
    <Column justifyContent="center" marginLeft={16} flex={1} minWidth={0}>
      {/* Row 1: Name + Rating + Profile */}
      <ProfessionalNameRow
        id={id}
        fullname={fullname}
        rating={rating}
        isAvailable
      />

      {isSmallScreen ? (
        <>
          {/* Small screen — Row 2: Profession * Experience */}
          <Row alignItems="center" style={{ whiteSpace: 'nowrap' }}>
            <Text color={textColor}>{UserProfession.getName(profession || '')}</Text>
            {yearsOfExperience != null && (
              <Text color={textColor}>
                &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                {yearsOfExperience} yr{yearsOfExperience !== 1 ? 's' : ''} Experience
              </Text>
            )}
          </Row>

          {/* Small screen — Row 3: Attendance */}
          {hasBadges && (
            <Row alignItems="center" gap={4} style={{ whiteSpace: 'nowrap' }}>
              <Text color={textColor}>Attendance:</Text>
              <AttendanceBadgeInline badges={badges} />
            </Row>
          )}

          {/* Small screen — Row 4: Activity Level */}
          {renderActivityLine()}
        </>
      ) : (
        <>
          {/* Big screen — Row 2: Profession * Experience * Attendance */}
          <Row alignItems="center" style={{ whiteSpace: 'nowrap' }}>
            <Text color={textColor}>{UserProfession.getName(profession || '')}</Text>
            {yearsOfExperience != null && (
              <Text color={textColor}>
                &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                {yearsOfExperience} yr{yearsOfExperience !== 1 ? 's' : ''} Experience
              </Text>
            )}
            {hasBadges && (
              <Row alignItems="center" gap={4}>
                <Text color={textColor}>&nbsp;&nbsp;&bull;&nbsp;&nbsp;Attendance:</Text>
                <AttendanceBadgeInline badges={badges} />
              </Row>
            )}
          </Row>

          {/* Big screen — Row 3: Activity Level */}
          {renderActivityLine()}
        </>
      )}
    </Column>
  );
};
